'use strict';

var Transport = require('../transport');

module.exports = function(funnel) {
  var transport = new Transport('/displays');

  return function(opt_data) {
    if (funnel._funnelWasSent) {
      var req = opt_data || {};

      req.url = document.location.href;
      funnel.addRelations(req);
      transport.debug = funnel.isDebug();

      transport.send(req);
    } else {
      funnel._preSendQueue.push({
        type: 'display',
        opt_data: opt_data
      });
    }
  };
};



//////////////////
// WEBPACK FOOTER
// ./lib/funnel/trackdisplays.js
// module id = 28
// module chunks = 1 3